<template>
  <div class="students">
    <div class="top-bar p-3">
      {{ trans_choice('core.students', 2) }}
    </div>
    <div
      class="m-2 flex-grow-1"
    >
      <div
        class="area p-3 d-flex flex-column justify-content-start"
        :class="isHovering ? 'area-student' : ''"
        @drop.prevent="dragDrop"
        @dragover.prevent="dragover"
        @dragenter.prevent="dragEnter"
        @dragleave.prevent="dragLeave"
      >
        <AssessmentConfigStudentItemView
          :students="students"
        />
      </div>
    </div>
  </div>
</template>

<script>
import toast from '@/services/toast'
import { mapState } from 'vuex'
import AssessmentConfigStudentItemView
  from '@/employees/components/AssessmentConfig/view/AssessmentConfigStudentItemView'

export default {
  name: 'AssessmentConfigStudentAreaView',
  components: {
    AssessmentConfigStudentItemView,
  },
  props: {
    eventId: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      isHovering: false,
    }
  },
  computed: {
    ...mapState({
      event (state) {
        return state.events.events[this.eventId]
      },
      events (state) {
        return this.event.childEvents ? this.event.childEvents.map(eventId => state.events.events[eventId]) : []
      },
      students (state) {
        return this.event.students
          ? this.event.students.filter(studentId => !this.eventStudents.includes(studentId)).map(studentId => state.students.students[studentId])
          : []
      },
    }),
    eventStudents () {
      return this.events.map(event => event.students).flat()
    },
  },
  methods: {
    dragEnter (event) {
      this.isHovering = true
    },
    dragover (event) {
      this.isHovering = true
    },
    dragLeave (event) {
      this.isHovering = false
    },
    dragDrop (event) {
      const payload = JSON.parse(event.dataTransfer.getData('text/plain'))
      if (payload.eventId && payload.studentId) {
        this.$store.dispatch('moveStudentToEvent',
          {
            data: {
              to: null,
              from: payload.eventId,
              student: payload.studentId,
            },
          },
        ).catch((e) => {
          return toast.warning(Lang.get('errors.move_not_possible'))
        }).finally(() => {
          this.isHovering = false
        })
      } else {
        this.isHovering = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
.students {
  border-width: 1px;
  border-left-width: 0px;
  border-color: darkgray;
  border-style: solid;
  background: #f2f2f2;
  display: flex;
  flex-direction: column;
}

.top-bar {
  height: 40px;
  background-color: #646B78;
  color: #ffffff;
}

.area {
  background: rgba(0, 0, 0, 0.1);
  border-color: darkslategray;
  border-radius: 0.375rem;
  z-index: 999;
  height: 100%;
  flex-grow: 1;
}

.student-item {
  background: #86BEDA;
  border-color: #007AA2;
  border-style: solid;
  border-radius: 0.375rem;
  border-width: 2px;
  height: 40px;
}

.area-student {
  background: rgba(0, 200, 255, 0.1);
  flex-grow: 1;
}
</style>
